module.exports = __webpack_public_path__ + "img/All-on-Four.66c4b30f.jpg";